














import { Vue, Component, Prop } from "vue-property-decorator";

// Types
import { IAccount } from "@/models/accounts";
import { IClient } from "@/models/clients";

@Component({
  components: {
    "client-notes-component": () =>
      import("@/components/app/global/client/clientNotesComp.vue"),
    "client-secrets-component": () =>
      import("@/components/app/global/client/clientSecretsComp.vue")
  }
})
export default class ClientVaultNotesView extends Vue {
  // Props

  @Prop({ required: true })
  public accountId!: IAccount["id"];

  @Prop({ required: false })
  public client!: IClient;

  // Computed

  public get isDisabled() {
    return (
      !!this.$_.get(this.client, "staged_import") ||
      !!this.$_.get(this.client, "import_id")
    );
  }
}
